module.exports = "/images/rts.svg?bf241285d296ea23dbdee3d85115a6b6";